import { PLUGIN_LOGO_ICON_COMPONENTS } from "metabase/plugins";

interface LogoIconProps {
  width?: number;
  height?: number;
  dark?: boolean;
  fill?: string;
}

export const DefaultLogoIcon = ({
  height = 32,
}: LogoIconProps) => {
  // Full Narvar wordmark: icon (blue) + "narvar" text (gray)
  // Original viewBox is 0 0 250 60, aspect ratio ~4.17:1
  const aspectRatio = 250 / 60;
  const computedWidth = height * aspectRatio;

  return (
    <svg
      viewBox="0 0 250 60"
      width={computedWidth}
      height={height}
      data-testid="main-logo"
    >
      <path
        fill="#009ADB"
        d="M53.5,30c0,6.8-5.5,12.3-12.3,12.3h-7c-0.8,0-1.4-0.6-1.4-1.4V30c0-4.1-3.3-7.4-7.4-7.4s-7.4,3.3-7.4,7.4v10.8
          c0,0.8-0.6,1.4-1.4,1.4h-2c-0.8,0-1.4-0.6-1.4-1.4V30c0-6.8,5.5-12.3,12.3-12.3S37.6,23.2,37.6,30v7.4h3.6c4.1,0,7.4-3.3,7.4-7.4
          V19.1c0-0.8,0.6-1.4,1.4-1.4h2c0.8,0,1.4,0.6,1.4,1.4c0,0,0,0.1,0,0.1L53.5,30z M32.9,0c-16.6,0-30,13.4-30,30s13.4,30,30,30
          s30-13.4,30-30S49.4,0,32.9,0z"
      />
      <path
        fill="#808184"
        d="M90,17.7c-6.8,0-12.3,5.5-12.3,12.3v11.5c0,0.4,0.3,0.7,0.7,0.7h1c0.4,0,0.7-0.3,0.7-0.7V30
          c0-5.4,4.4-9.8,9.8-9.8s9.8,4.4,9.8,9.8v11.5c0,0.4,0.3,0.7,0.7,0.7h1c0.4,0,0.7-0.3,0.7-0.7V30C102.2,23.2,96.8,17.7,90,17.7z"
      />
      <path
        fill="#808184"
        d="M117.5,39.7c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.8-9.8c5.4,0,9.8,4.4,9.8,9.8S122.9,39.7,117.5,39.7z
          M129.7,41.5V29.9c0-6.8-5.5-12.3-12.3-12.3s-12.3,5.5-12.3,12.3l0,0c0,6.8,5.5,12.3,12.3,12.3c4,0,7.5-1.9,9.8-4.9v4.2
          c0,0.4,0.3,0.7,0.7,0.7h1C129.4,42.2,129.7,41.9,129.7,41.5z"
      />
      <path
        fill="#808184"
        d="M144.9,17.7c-6.8,0-12.3,5.5-12.3,12.3v11.5c0,0.4,0.3,0.7,0.7,0.7h1c0.4,0,0.7-0.3,0.7-0.7V30
          c0-5.4,4.4-9.8,9.8-9.8c5.2,0,9.4,4,9.8,9.1c0,0.4,0.3,0.7,0.7,0.7h1c0.4,0,0.7-0.3,0.7-0.7C156.8,22.8,151.5,17.7,144.9,17.7z"
      />
      <path
        fill="#808184"
        d="M181.7,18.4c0-0.4-0.3-0.7-0.7-0.7h-1c-0.4,0-0.7,0.3-0.7,0.7V30c0,5.4-4.4,9.8-9.8,9.8h-6.8V30V18.4
          c0-0.4-0.3-0.7-0.7-0.7h-1c-0.4,0-0.7,0.3-0.7,0.7V30v9.8v2.5v0h9.8v0c6.5-0.3,11.7-5.6,11.7-12.2L181.7,18.4L181.7,18.4z"
      />
      <path
        fill="#808184"
        d="M196.9,39.7c-5.4,0-9.8-4.4-9.8-9.8c0-5.4,4.4-9.8,9.8-9.8c5.4,0,9.8,4.4,9.8,9.8S202.3,39.7,196.9,39.7z
          M209.2,30L209.2,30c0-6.8-5.5-12.3-12.3-12.3s-12.3,5.5-12.3,12.3l0,0c0,6.8,5.5,12.3,12.3,12.3c4,0,7.5-1.9,9.8-4.9v4.2
          c0,0.4,0.3,0.7,0.7,0.7h1c0.4,0,0.7-0.3,0.7-0.7L209.2,30L209.2,30z"
      />
      <path
        fill="#808184"
        d="M224.4,17.7c-6.8,0-12.3,5.5-12.3,12.3v11.5c0,0.4,0.3,0.7,0.7,0.7h1c0.4,0,0.7-0.3,0.7-0.7V30
          c0-5.4,4.4-9.8,9.8-9.8c5.2,0,9.4,4,9.8,9.1c0,0.4,0.3,0.7,0.7,0.7h1c0.4,0,0.7-0.3,0.7-0.7C236.2,22.8,230.9,17.7,224.4,17.7z"
      />
      <g>
        <g>
          <path
            fill="#808184"
            d="M240.9,21.5h-0.5V23h-0.5l0-3.6h1.3c0.7,0,1.1,0.5,1.1,1.1c0,0.5-0.3,0.9-0.9,1l0.9,1.5h-0.6L240.9,21.5z
              M241.1,21.1c0.4,0,0.7-0.2,0.7-0.6c0-0.4-0.3-0.6-0.7-0.6h-0.7v1.2H241.1z"
          />
        </g>
        <path
          fill="#808184"
          d="M241,24.9c-2,0-3.7-1.7-3.7-3.7s1.7-3.7,3.7-3.7s3.7,1.7,3.7,3.7S243,24.9,241,24.9z M241,18
            c-1.8,0-3.2,1.4-3.2,3.2s1.4,3.2,3.2,3.2s3.2-1.4,3.2-3.2S242.8,18,241,18z"
        />
      </g>
    </svg>
  );
};

export function LogoIcon(props: LogoIconProps) {
  const [Component = DefaultLogoIcon] = PLUGIN_LOGO_ICON_COMPONENTS;
  return <Component {...props} />;
}
